import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { queryUserTreeList } from '@/api/api';
import SelectAssetModal from "../../../assets/SelectAssetModal";
import CommentDrawer from "./CommentDrawer.vue";
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'JobOrderModal',
  mixins: [ModalFormMixin],
  components: {
    SelectAssetModal: SelectAssetModal,
    CommentDrawer: CommentDrawer,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '派工单表单',
      siteName: '',

      /* 站点ID*/
      siteId: null,
      operationType: null,
      tableName: 'om_job_order',
      form_fields: [// 'siteId',
      // 'originId',
      // 'originKey',
      'tenantId', 'userId', 'category', 'jobLevel', // 'assetId',
      // 'errorCode',
      'remark', 'title', 'solution', 'status'],
      form_fields_time: ['startTime', 'endTime', 'completionTime', 'processingTime'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择处理人员!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择任务类型'
          }]
        },
        jobLevel: {
          rules: [{
            required: true,
            message: '请选择任务级别'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入标题!'
          }]
        },
        startTime: {
          rules: [{
            required: true,
            message: '请选择开始时间!'
          }]
        },
        endTime: {
          rules: [{
            required: true,
            message: '请选择结束时间!'
          }]
        },
        originKey: {
          rules: [{
            required: true,
            message: '请选择故障来源!'
          }]
        }
      },
      url: {
        add: '/om/job/order'
      },
      userTree: [],
      //人员信息
      selectedAsset: [],
      assetIds: []
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    },
    currentSiteId: function currentSiteId(newVal) {
      this.siteId = newVal;
    }
  },
  created: function created() {
    this.siteName = sessionStorage.getItem('siteName');
  },
  methods: {
    // 判断输入框状态
    isUser: function isUser(item) {
      return this.$store.getters.userInfo.id != item.userId || item.finishFlag == 1;
    },
    isLastCommitUser: function isLastCommitUser(jobOrderSendVoList) {
      return jobOrderSendVoList.filter(function (item) {
        return item.finishFlag == '1';
      }).length == jobOrderSendVoList.length;
    },
    add: function add(originKey) {
      this.edit(originKey);
    },
    edit: function edit(record) {
      var _this = this;

      // debugger
      this.visible = true;
      console.log('model', record);
      this.isRead(record);
      this.$nextTick(function () {
        _this.form.resetFields();

        _this.model = Object.assign({}, record);

        if (_this.model.userId) {
          _this.model.userId = _this.model.userId.split(',');
        }

        _this.model.siteId = _this.siteId ? _this.siteId : _this.model.siteId;
        console.log('model', _this.model);
        /*this.model.siteName = this.siteName
          this.model.siteId = sessionStorage.getItem('siteId')
          this.model.operationType = sessionStorage.getItem('operationType')*/
        // debugger
        // if (this.model.id) {
        //
        // } else {
        //   debugger
        //   this.model.siteId = this.siteId
        //   this.model.siteName = this.siteName
        //   this.model.operationType = this.operationType
        //   this.model.title = ''
        //   this.model.errorCode = ''
        //   console.log('this.model', this.model)
        // }

        console.log('this.model', _this.model);

        _this.$nextTick(function () {
          _this.loadTreeList();

          _this.selectedAsset = [];
          _this.assetIds = [];
          _this.disableSubmit = _this.showCheck ? true : _this.disableSubmit;

          if (_this.model.id || _this.addJob) {
            _this.assetIds = _this.model.assetId ? _this.model.assetId : null;
            _this.model.productName = _this.model.productName ? _this.model.productName : null;

            _this.selectedAsset.push(_this.model.productName);

            _this.siteName = _this.model.siteName;
          } else {// this.model.startTime = new Date().toLocaleDateString()
          }

          var that = _this;
          that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

          var timeVal = {};
          that.form_fields_time.forEach(function (item, index) {
            timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
          });
          that.form.setFieldsValue(timeVal);
          console.log('that.form', that.form);
          that.$refs.iwupload.loadUploadFiles();
        });
      });
    },
    // 判断是否已读
    isRead: function isRead(record) {
      var _this2 = this;

      if (record.jobOrderSendVoList && record.jobOrderSendVoList.length > 0) {
        var selectedUser = record.jobOrderSendVoList.filter(function (item) {
          return item.userId == _this2.$store.getters.userInfo.id && item.readFlag == '2';
        });

        if (selectedUser.length > 0) {
          httpAction("/job/order/send/editByJobIdAndUserId", {
            jobId: selectedUser[0].jobId
          }, 'put').then(function (res) {
            record.jobOrderSendVoList.filter(function (item) {
              if (item.userId == _this2.$store.getters.userInfo.id) {
                item.readFlag = '1';
                item.readFlag_dictText = '已读';
              }
            });

            _this2.$emit('ok');
          });
        }

        console.log('selectedUser', selectedUser);
      }
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    selectAssets: function selectAssets() {
      // this.$refs.AssetListModal.siteId = this.currentSiteId
      this.$refs.AssetListModal.siteId = this.model.siteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(this.selectedAsset, this.assetIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedAsset = [];
      this.assetIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedAsset.push(productList[i].productName);
        this.assetIds = productList[i].id;
      }
    },
    handleOk: function handleOk(s) {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData = _.cloneDeep(formData);
          console.log('formData', formData); //时间格式化

          formData.endTime = formData.endTime ? formData.endTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.startTime = formData.startTime ? formData.startTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.completionTime = formData.completionTime ? moment(formData.completionTime).format('YYYY-MM-DD HH:mm:ss') : null;
          formData.processingTime = formData.processingTime ? moment(formData.processingTime).format('YYYY-MM-DD HH:mm:ss') : null;
          formData.assetId = that.assetIds && (that.assetIds == [] || that.assetIds.length == 0) ? '' : that.assetIds;
          formData.siteId = formData.siteId ? formData.siteId : _this3.model.siteId;
          formData.userId = formData.userId.join(',');
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
            formData.jobOrderSendVoList.forEach(function (item) {
              if (!_this3.isUser(item) && formData.status > 1) {
                item.finishFlag = '1';
                item.completeTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              }
            });
          } // 开始处理时间


          if (_this3.model.id && _this3.model.status == 1 && _this3.model.userId.includes(_this3.$store.getters.userInfo.id + '')) {
            formData.processingTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          }

          if (_this3.model.id && _this3.model.status == 2) {
            console.log('status'); // 完成时间加判断  最后一个人提交时即为完成状态

            if (_this3.isLastCommitUser(formData.jobOrderSendVoList)) {
              formData.completionTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              formData.status = 3;
            } else {
              formData.status = 2;
            }
          } else {
            formData.status = !formData.status ? 1 : s == 2 ? 2 : s == 3 ? 3 : s == 1 ? formData.status : 1;
          } // return


          console.log('formData', formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};